import React, {useState} from 'react';
import {cnSettingsMenu, ISettingsMenuGroupProps} from "../SettingsMenu";
import {KitchenService} from '../../../../3d/services/KitchenService/KitchenService';
import './SettingsMenu-Handles.css';
import {ISettingGroupHandles} from "../../../../interfaces/settingData/ISettingGroupHandles";
import {ISettingHandle} from "../../../../interfaces/settingData/ISettingHandle";
import {GOOD_TYPE_HANDLE} from "../../../../../common-code/constants";
import {DetailSettingsMenuHandle} from "../DetailSettingsMenu/DetailSettingsMenuHandle";

export interface ISettingsMenuHandlesGroupProps extends ISettingsMenuGroupProps {
    handlesData: ISettingGroupHandles;
    service: KitchenService;
    unitId: number;
}

export const SettingsMenuHandles: React.FC<ISettingsMenuHandlesGroupProps> =
    ({className, onRebuildDetailData, handlesData, service, unitId}) => {
        const [hover, setHover] = useState<boolean>(false);

        if (!onRebuildDetailData) {
            return null;
        }

        return (
            <div className={cnSettingsMenu('Handles', [className])}>
                {
                    handlesData.items.map((settingHandle: ISettingHandle, index: number) => {
                        return (
                            <div className={cnSettingsMenu('Handle', {hover: hover})}
                                 key={index}
                                 onMouseEnter={() => {
                                     setHover(true)
                                 }}
                                 onMouseLeave={() => {
                                     setHover(false)
                                 }}
                            >
                                <DetailSettingsMenuHandle data={settingHandle.saveData}
                                                          onRebuildData={onRebuildDetailData}
                                                          service={service}
                                                          createUnit={handlesData.createUnit}
                                                          handleData={{
                                                              type: GOOD_TYPE_HANDLE,
                                                              unitId: unitId,
                                                              handleData: settingHandle.object,
                                                              facadeData: settingHandle.facadeData,
                                                              detailId: settingHandle.detailId,
                                                              autoPosition: settingHandle.autoPosition,
                                                              hasCustomPosition: settingHandle.hasCustomPosition,
                                                              customPosition: settingHandle.customPosition,
                                                              facadeMaterial: settingHandle.facadeMaterial,
                                                              level: settingHandle.level,
                                                              isDelete: settingHandle.isDelete,
                                                          }}
                                />
                            </div>

                        );
                    })
                }
            </div>
        );
    }
